import React, {useState, useEffect} from 'react'
import {inject, observer} from 'mobx-react'
import {getDeviceBlock} from '@apis'
import Chart from '@components/chart'
import ChartBlock from '@components/chartBlock'

const DeviceRegionDistribute = inject('store')(
  observer(({store}) => {
    const {userInfo = {}} = store
    const {strongProjectId: projectId} = userInfo

    const [deviceRegionChartData, setDeviceRegionChartData] = useState([])
  
    async function queryDeviceBlock() {
      const params = {
        projectId
      }
      const res = await getDeviceBlock(params)
      if (res) {
        setDeviceRegionChartData(res)
      }
      console.log('res--', res)
    }
  
    useEffect(() => {
      queryDeviceBlock()
    }, [])
  
    const renderDeviceRegionChart = (instance, opts) => {
      let count = 0
      for(let i=0; i<opts.data.length; i++) {
        if(count < opts.data[0].count) {
          count = opts.data[0].count
        }
      }
      instance.data(opts.data);
      instance.scale('count', {
        min: 0,
        max: count+1,
      }
      );
      instance.tooltip({
        showCrosshairs: false,
      });
  
      instance.interaction('active-region');
  
      instance.interval().position('areaName*count');
  
      instance.render();
    }
  
    return (
      <ChartBlock
        title="配电柜区域分布"
      >
        {
          deviceRegionChartData.length ? (
            <Chart renderChart={renderDeviceRegionChart} style={{height: 250}} data={deviceRegionChartData} />
          ) : null
        }
      </ChartBlock>
    )
  })
)
export default DeviceRegionDistribute
